module.exports = __webpack_public_path__ + "img/image9.cb927960.png";